// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2g95z","buttons":"PendingPaymentAlert_buttons__2HBUd"};